module.exports = __webpack_public_path__ + "static/media/calendar_month_white_24dp.2f5e073a.svg";